import React, {useState} from "react";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import "./_filtering-accordion-item.scss";
import ChevronIconBlue from '../../../assets/icons/chevron-down-blue.svg';
import CancelIconBlue from '../../../assets/icons/cancel-icon-blue.svg';
import {useSelector} from "react-redux";
import {RootState} from "../../../../store/configureStore";
import {TenantAppVersionConfig} from "../../../../constants/Config";

const baseClass = 'filtering-accordion-item';

interface PropTypes {
  accordionTitle: string;
  filterOption: any;
  handleFilterOption?: any;
  filterType: string
  handleOptionSelections?: any
  selectedGenderOption?: {type: string, name: string}[] | null
  savedInclusion?: any
  selectedDayOption?: any
}

const FilteringAccordionItem = (props: PropTypes): JSX.Element => {
  let accordionDetail;
  const [expanded, setExpanded] = useState(false)
  const tenant = useSelector((state: RootState) => state.widgetConfigurationSettings.tenant);

  if (props.filterType == 'days') {
     accordionDetail = props.filterOption.map((option: any, index: number) =>
      <button className={`${baseClass}--demographic-detail ${props.selectedDayOption && props.selectedDayOption.includes(option) ? 'selected' : ''}`} onClick={() => props.handleFilterOption(option)} key={`days-${index}`}>
        <img className={'cross-icon'} src={TenantAppVersionConfig[tenant].icons.cancel}/>
        <div>{option}</div>
      </button>
    );
  } else if (props.filterType == 'inclusions') {
    accordionDetail = props.filterOption.map((option: any, index: number) =>
      <button className={`${baseClass}--demographic-detail ${props.savedInclusion && props.savedInclusion.includes(option.inclusionPlayHQValue) ? 'selected' : ''}`} onClick={() => props.handleFilterOption(option)} key={`inclusion-${index}`}>
        <img className={'cross-icon'} src={TenantAppVersionConfig[tenant].icons.cancel}/>
        <div>{option.inclusionDisplayValue}</div>
      </button>
    );
  } else {
    accordionDetail = props.filterOption.map((option: any, index: number) =>
      <button className={`${baseClass}--demographic-detail ${props.selectedGenderOption && props.selectedGenderOption.some(item => item.type === option.type) ? 'selected' : ''}`} onClick={() => props.handleOptionSelections(option)} key={`gender-${index}`}>
        <img className={'cross-icon'} src={TenantAppVersionConfig[tenant].icons.cancel}/>
        <div>{option.name}</div>
      </button>
    );
  }

  return (
    <div className={`${baseClass} ${tenant}`}>
      <Accordion onChange={() => setExpanded(!expanded)}>
        <AccordionSummary
          expandIcon={<img src={TenantAppVersionConfig[tenant].icons.chevronDown}/>}
          className={`${baseClass}--accordion-summary`}
        >
          <Typography className={`${baseClass}--typography`}>{props.accordionTitle}</Typography>
          <div className={'view-all-text'}>{expanded ? 'View Less' :'View All'}</div>
        </AccordionSummary>
        <AccordionDetails>
          {accordionDetail}
        </AccordionDetails>
      </Accordion>
    </div>
  )
}

export default FilteringAccordionItem;
